import React from 'react';
import {Link} from 'react-router-dom';

import {properties, users} from '../seed/data';
import profile from '../imgs/profile.jpg';

class UserMessages extends React.Component {
    constructor(props) {
        super(props);
    }

    render () {
        let userId = '123';
        let p = properties[0];
        let u = users[0]
        return (
            <div className="container frame">
                <div className="col-md-8 offset-md-2">
                    <h4 className="flex-space-between">Inbox </h4>
                    <ul className="p-list">
                    <Link to={`/property/${u.id}/message/sih91`} className="p-list-item-link">
                        <li className="p-list-item d-flex">
                            <div className="inbox-img">
                                <img src={profile} />
                            </div>
                            <div className="inbox-user">{u.firstName} {u.lastName}</div>
                            <div className="inbox-content">
                                <div className="inbox-address">{p.address}</div>
                                <div className="inbox-msg">I wish to book a viewing on Friday</div>
                            </div>
                        </li>
                    </Link>
                    </ul>
                </div>
            </div>
        )
    }
}

export default UserMessages;